import AppSettings from "../appsettings";
import { getCurrentUser } from "../services/auth/currentUser";
import * as analyticsFunctions from "./analyticsFunctions.js";

const config = {
  appId: analyticsFunctions.getAppId(),
  section: "Product",
  subsection: "Featured Technology",
};
const isLocal = AppSettings?.hostUrl === "http://localhost";

// Signed-out pages have always sent null rather than "" for profile fields.
const userAnalyticsFields = (positionTitle) => {
  const { dealerCode, regionCode, jobCode, spinId } = getCurrentUser();
  return {
    "<user_name>": localStorage.getItem("username"),
    "<dealer_code>": dealerCode || null,
    "<user_type>": localStorage.getItem("user_type"),
    "<region>": regionCode || null,
    "<position_title>": positionTitle,
    "<job_code>": jobCode || null,
    "<spin_id>": spinId || null,
  };
};

export class GlobalAnalytics {
  constructor() {
    this.pageLoadTag = "35.1";
    this.onClickTag = "35.2";
  }

  firePageLoad = function firePageLoad(params) {
    let positionTitle = localStorage
      ? localStorage.getItem("position_title")
      : "POSITION_TITLE";
    if (params.positionTitle) {
      positionTitle = params.positionTitle;
    }
    if (isLocal) {
      // eslint-disable-next-line no-console
      console.log("[analytics.pageLoad] params", pruneUndefined(params));
    }

    const body = {
      ...userAnalyticsFields(positionTitle),

      //Page Analytics
      "<app_id>": config.appId,
      "<site_size>": analyticsFunctions.getSiteSize(),
      "<viewport>": analyticsFunctions.getViewPort(),
      "<model_name>": params.modelName || "",
      "<model_year>": params.modelYear || "",
      "<model_code>": params.modelCode || "",
      "<trim>": params.trim || "",
      "<model_engine>": params.modelEngine || "",
      "<model_cab>": params.modelCab || "",
      "<model_bed>": params.modelBed || "",
      "<model_drivetrain>": params.modelDrivetrain || "",
      "<page>": params.page || "",
      "<section>": params.section || "",
      "<subsection>": params.subsection || "",
      "<technology_name>": params.technologyName || "",
      "<content_title>": params.contentTitle || "",
      "<media_title>": params.mediaTitle || "",

      //Skills Specific
      "<category_topic>": params.categoryTopic || "",

      // Article Specific
      "<article_type>": params.articleType || "",

      // Search Specific
      "<description>": params.description || "",
      "<keyword>": params.keyword || "",
      "<number_of_search_results>": params.numberOfSearchResults || "",

      // Hybrid App
      "<platform>": window.ReactNativeWebView ? "App" : "Web",
      "<os_version>":
        sessionStorage?.getItem("app_device_os") ||
        localStorage?.getItem("app_device_os") ||
        "",
      "<app_version>":
        sessionStorage?.getItem("app_version") ||
        localStorage?.getItem("app_version") ||
        "",
    };
    const tag = params.tag ? params.tag : this.pageLoadTag;
    fireTagWhenReady(tag, body);
  };

  fireOnClick = function fireOnClick(params) {
    let positionTitle = localStorage
      ? localStorage.getItem("position_title")
      : "POSITION_TITLE";
    if (params.positionTitle) {
      positionTitle = params.positionTitle;
    }
    if (isLocal) {
      // eslint-disable-next-line no-console
      console.log("[analytics.onClick] params", pruneUndefined(params));
    }
    const body = {
      ...userAnalyticsFields(positionTitle),

      //Page Analytics
      "<app_id>": config.appId,
      "<viewport>": analyticsFunctions.getViewPort(),
      "<site_size>": analyticsFunctions.getSiteSize(),

      "<page>": params.page || "",
      "<section>": params.section || "",
      "<subsection>": params.subsection || "",
      "<technology_name>": params.technologyName || "",
      "<media_title>": params.mediaTitle || "",
      "<category>": params.category || "",
      "<content_title>": params.contentTitle || "",
      "<container>": params.container || "",
      "<label>": params.label || "",
      "<model_name>": params.modelName || "",
      "<model_year>": params.modelYear || "",
      "<model_code>": params.modelCode || "",
      "<trim>": params.trim || "",
      "<model_engine>": params.modelEngine || "",
      "<model_cab>": params.modelCab || "",
      "<model_bed>": params.modelBed || "",
      "<model_drivetrain>": params.modelDrivetrain || "",
      "<module>": params.module || "",
      // Skills Specific
      "<category_topic>": params.categoryTopic || "",
      // Video Player Specific
      "<events>": params.events || "",
      "<video_length>": params.videoLength || "",
      // Articles Specific
      "<article_type>": params.articleType || "",
      "<tile_position>": params.tilePosition || "",
      // Cert & Dropdown specific
      "<action>": params.action || "",
      // Search Specific
      "<keyword>": params.keyword || "",
      "<number_of_search_results>": params.numberOfSearchResults || "",
      // Hybrid App
      "<platform>": window.ReactNativeWebView ? "App" : "Web",
      "<os_version>":
        sessionStorage?.getItem("app_device_os") ||
        localStorage?.getItem("app_device_os") ||
        "",
      "<app_version>":
        sessionStorage?.getItem("app_version") ||
        localStorage?.getItem("app_version") ||
        "",
    };

    const tag = params.tag ? params.tag : this.onClickTag;
    fireTagWhenReady(tag, body);
  };
}

// ===== Utils =====
// Remove only keys whose value is strictly undefined; keep null/false/0/'' as-is
const pruneUndefined = (obj) => {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined),
  );
};

const MAX_FIRE_TAG_RETRIES = 10;
const FIRE_TAG_RETRY_DELAY_MS = 300;

// Retry firing until the global fireTag is available
const fireTagWhenReady = (tag, body, attemptsLeft = MAX_FIRE_TAG_RETRIES) => {
  const fireTagFn = window.fireTag;
  if (typeof fireTagFn === "function") {
    fireTagFn(tag, body);
    return;
  }
  if (attemptsLeft > 0) {
    setTimeout(
      () => fireTagWhenReady(tag, body, attemptsLeft - 1),
      FIRE_TAG_RETRY_DELAY_MS,
    );
  }
};
